<div data-cy="earnings-wrapper"
     class="earnings-count-wrapper"
     [ngClass]="{'toggle': toggle, 'show': show}"
     (click)="toggleCounter()">
  <span data-cy="earnings-btn" class="number">{{userFunds | currency:'USD':'symbol':'1.0-0'}}</span>
  <a data-cy="earnings-link-btn" *ngIf="userData" [routerLink]="['/user', userData.id, 'earnings']" class="label">Your earnings</a>
</div>
